// components/group/feed/utils/feedItemType.js
export function getFeedItemKind(item) {
  if (!item) return 'post';

  const t =
    (item.type || item.content_type || item.kind || item.item_type || '')
      .toString()
      .toLowerCase();

  if (t === 'course') return 'course';

  // If a `content_ref` points to courses, treat it as course
  if (item?.content_ref?.collection === 'courses') return 'course';

  // Back-compat
  if (item.course || item.course_data || item.courseId || item.course_id) return 'course';

  return 'post';
}

export function getCourseFromItem(item) {
  if (!item) return null;
  // Full embedded course (rare)
  return item.course || item.course_data || item.courseContent || null;
}

export function getCourseIdFromItem(item) {
  if (!item) return null;
  return (
    item?.content_ref?.id ||
    item?.course_id ||
    item?.courseId ||
    item?.course?.id ||
    item?.course_data?.id ||
    null
  );
}
